import { icons } from 'common'
import styled from 'styled-components'
import { FeesStructureModalCSS } from './FeesStructureCSS.styled'

export const FeesStructureModal = ({ closeModal }) => {
  return (
    <ModalBox>
      <FeesStructureModalCSS>
        <div className='popUpContainer fees_calc width-500'>
          <CloseWindowIcon onClick={() => closeModal()} />
          <article>
            <h1>Fees</h1>

            <div className='fees_on_profit_wrap'>
              <div className='subtitle'>Fees on profit</div>
              <ul>
                <li>
                  The fee for winning trades operates on a sliding scale and depends on both the leverage, with a higher
                  percentage taken when leverage is high, and the price movement, where a smaller percentage is taken
                  when there's a larger price move.
                </li>
                <li>
                  This fee is already incorporated into the user interface, so the displayed P&amp;L is the amount you
                  will receive if you close the trade, as the fee has already been accounted for.
                </li>

                {/* <li>Fees calculations are subject to change without notice</li> */}
              </ul>
            </div>
            <div className='upfront_fees_wrap'>
              <div className='subtitle'>Upfront fees</div>

              <div className='grid-body fees_tables'>
                <div className='grid-header'>
                  <label>Bids in 24 hours</label>
                  <label>Upfront fees</label>
                </div>
                <div className='grid-content'>
                  <label>&lt; 50</label>
                  <label>0%</label>
                  <label>50 - 250</label>
                  <label>5%</label>
                  <label>250 - 500</label>
                  <label>7.5%</label>
                  <label>&gt; 500</label>
                  <label>10%</label>
                </div>
              </div>
            </div>
            <div class='footnote'>* All fees calculations are subject to change in the future</div>
          </article>
        </div>
      </FeesStructureModalCSS>
    </ModalBox>
  )
}

const ModalBox = styled.div`
  position: fixed;
  width: 100%;
  min-width: 300px;
  max-width: 600px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);3e
  -webkit-box-shadow: 0 0 100px rgb(0 0 0 / 40%);
  -moz-box-shadow: 0 0 100px rgba(0, 0, 0, 0.4);
  box-shadow: 0 0 100px rgb(0 0 0 / 40%);
  border-radius: 10px;
  z-index: 99;
  transition: top 0.5s ease;
  max-width: 520px;

  -webkit-transition: top 0.5s ease;
  -moz-transition: top 0.5s ease;
  -o-transition: top 0.5s ease;
`
const CloseWindowIcon = styled.div`
  top: -5px;
  left: -5px;
  -webkit-mask: url(${icons.close_window_icon}) center center / 22px auto no-repeat;
  mask: url(${icons.close_window_icon}) center center / 22px auto no-repeat;
  background: hsl(0, 0%, 100%);
  width: 22px;
  height: 22px;
  display: block;
  position: absolute;
  color: #fff;
  text-decoration: none;
  text-decoration-color: rgba(255, 255, 255, 0.4);
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
  z-index: 2;
  cursor: pointer;

  &:hover {
    background: #c0392b;
  }
`
